// extracted by mini-css-extract-plugin
export default {"dropbtn":"PositionMenu2_dropbtn__40yC+","dropdown":"PositionMenu2_dropdown__tbec1","dropdownContent":"PositionMenu2_dropdownContent__sQxuu"};